import React, { useState } from "react";
import axios from "axios";
import Forecast from "./Forecast";
import Footer from "./Footer";
import DayJS from "react-dayjs";
import WeatherIcon from "./WeatherIcon";

export default function Search(props) {
  let [city, setCity] = useState(props.dCity);
  let [message, setMessage] = useState("");
  const [temperature, setTemperature] = useState(null);

  let [wind, setWind] = useState(null);
  let [humidity, setHumidity] = useState(null);
  let [description, setDescription] = useState("");
  let [icon, setIcon] = useState(null);
  let [lat, setLat] = useState(null);
  let [long, setLong] = useState(null);
  let [Foreacast_min, setForecast_min] = useState(null);
  let [Foreacast_max, setForecast_max] = useState(null);
  let [Foreacast_dt, setForecast_dt] = useState(null);
  // let [Foreacast_icon, setForecast_icon] = useState(null);
  //let [ForecastInfo, setForecastInfo] = useState(null);
  //let iconUrl;
  // let temp = null;

  const date = "";

  console.log(props);
  //let days = ["Sun", "Tues", "Wedn", "Thurs", "Friday", "Saturday"];

  function showTemp(response) {
    console.log(response.data);
    //kelvin to Celsius
    setTemperature(Math.round(response.data.main.temp - 273.15));
    setWind(response.data.wind.speed);
    setHumidity(response.data.main.humidity);
    setDescription(response.data.weather[0].description);
    setCity(response.data.name);
    // iconUrl = `http://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`;

    //temp = response.data.main.temp;
    // eslint-disable-next-line
    setIcon(response.data.weather[0].icon);
    setLat(response.data.coord.lat);
    setLong(response.data.coord.lon);
    setForecast_min(response.data.main.temp_min);
    setForecast_max(response.data.main.temp_max);
    setForecast_dt(response.data.dt);
    // setForecast_icon(response.data.weather[0]);
    // setForecastInfo(Foreacast_min, Foreacast_max, Foreacast_dt, Foreacast_icon);
  }

  //day forecast
  function day() {
    let dates = new Date(Foreacast_dt);
    let day = dates.getDay();
    let days = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];
    return days[day];
  }
  // fin day forecast

  function handleSubmit(event) {
    event.preventDefault();
    let url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=f730e91b30cbe17d7d77b0e941835ced&units=metrics`;

    axios.get(url).then(showTemp);

    setMessage(`${city}`);
  }

  function onSearch(event) {
    setCity(event.target.value);
  }

  function ShowFarhenheit(event) {
    event.preventDefault();
    // let temperature = ((props.temp * 9) / 5) * 32;
    setTemperature(Math.round(temperature * 1.8) + 32);
    //alert(`${Math.round(temperature)} ° F`);
  }

  function showCelsus(event) {
    event.preventDefault();
    //let tempe = props.temp;
    // setTemperature((Math.round(temperature * 9) / 5) * 32);
    let t = Math.round((temperature - 32) / 1.8) + 273.15;
    let te = t - 273.15;

    setTemperature(te);

    //alert(`${tempe}`);
  }

  //Forecast

  function showWeatherForecast(response) {
    console.log(response.data);
  }

  let apiKey = "f730e91b30cbe17d7d77b0e941835ced";

  let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${lat}&lon=${long}&appid=${apiKey}`;

  axios.get(apiUrl).then(showWeatherForecast);

  return (
    <div class="container weather_app">
      <div class="row ">
        <div class="container-fluid">
          <form class="d-flex" onSubmit={handleSubmit}>
            <input
              class="form-control me-2"
              id="input_form"
              type="search"
              placeholder="Enter the name of the city"
              aria-label="Search"
              onChange={onSearch}
            />
            <button class="btn btn-outline-success" id="success" type="submit">
              Search
            </button>
          </form>

          <DayJS asString={true}>{date}</DayJS>
          <h2>{message}</h2>
          <WeatherIcon code={icon} />
          <div class="row" id="temp_city">
            <div class="weather_bloc">
              <span class="noteTemp">
                <ul>
                  <a
                    href="/"
                    id="tempCelsus"
                    //eslint-disable-next-line
                    class="temp_cel_far celsLink"
                    //eslint-disable-next-line
                    class="active"
                    onClick={showCelsus}
                  >
                    °C |
                  </a>
                  <a
                    href="/"
                    id="tempFarhenheit"
                    onClick={ShowFarhenheit}
                    class="active"
                  >
                    ° F
                  </a>

                  <li class="temp">{temperature}</li>
                </ul>
              </span>
            </div>
          </div>
          <div class="">
            <ul>
              <span>
                Wind : {wind}
                <li class="wind_speed" id="extra_info_weather"></li>
              </span>
              <span>
                Humidity : {humidity}
                <li class="humidity" id="extra_info_weather"></li>
              </span>
              <span>
                {description}
                <li class="humidity" id="extra_info_weather"></li>
              </span>
            </ul>
          </div>
        </div>
      </div>

      <div className="Forecast">
        <div className="row">
          <div className="col">
            <div className="Foreacast-day">{day()} </div>
            <div className="Forecast-icon">
              <WeatherIcon code={icon} />
            </div>
            Longitude :{Math.round(lat)}
            <br />
            Latitude : {Math.round(long)}
            <div className="Forecast-temperature">
              <span className="Foreacast-temp-max">
                Temp-min : {Math.round(Foreacast_min)}
              </span>
              <br />
              <span className="Foreacast-temp-min">
                Temp-max : {Math.round(Foreacast_max)}
              </span>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <Forecast />
    </div>
  );
}
